import GeneralQAReport from "./GeneralQAReport.component";

export default GeneralQAReport;
